import React, { useEffect, useRef, useState } from 'react';

export function LazyComponent({ children, fallback, rootMargin = '50px' }) {
  const [inView, setInView] = useState(false);
  const placeholderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setInView(true);
            observer.disconnect();
          }
        }
      },
      { 
        rootMargin,
        threshold: 0.1
      }
    );

    if (placeholderRef.current) {
      observer.observe(placeholderRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [rootMargin]);

  return (
    <div ref={placeholderRef} style={{ width: '100%', height: '100%' }}>
      {inView ? children : fallback}
    </div>
  );
}
